import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Row, Col, Input, Button, Table, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import { isEmpty } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import ModalPopup from '../../components/ModalPopup';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import IconPlus from '../../assets/images/icon-plus.png';
import IconSearch from '../../assets/images/icon-search.png';
import PriceUtils from '../../helpers/PriceUtils';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import IconCalendarBlack from '../../assets/images/icon/ic_calendar-black.svg';
import ReceiptsAdd from './PaymentAdd';
import IconEdit from "../../assets/images/icon-edit.png";
import { ReceiptsGroup } from '../receipts/ReceiptsList';


const configPage = {
    titlePage: 'Danh sách phiếu chi',
    pathPage: '/payment',
    column: 9,
}

export const StatusList: any = [
    {
        value:"",
        label: "-Trạng thái-"
    },
    {
        value:0,
        label: "Mới"
    },
    {
        value:1,
        label: "Đã thu"
    },
]


export const PaymentMethod = [
    {
        value:"",
        label: "-Hình thức chi-"
    },
    {
        value:"cash",
        label: "Tiền mặt"
    },
    {
        value:"transfer",
        label: "Chuyển khoản"
    },
]

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {}
}

const List: React.FC<Props> = (props: Props) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState<any>({});
    const [customers, setCustomers] = useState([]);
    const [user, setUser] = useState([]);
    const [branch, setbranch] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [type, setType] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState([]);
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
        getFilterParams()
        loadInit()
    }, []);

    useEffect(() => {
        if(searchPrams?.payment_id) handleActionModal({type: 'view', data: {id: searchPrams?.payment_id}})
    }, [searchPrams?.payment_id]);

    useEffect(() => {
        loadData()
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
        });
    }, [filter, page, limit]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseType,
            responseUser,
            responseBranch,
            responseCustomer,
            responseSupplier,
            responsePaymentMethod
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/receiptstype`, {
                ...params,
                type: 'payment'
            }),
            APIClient.GET(`${baseUrl}/user`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/branch`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/customer`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/supplier`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/payment-method`, {
                ...params,
            }),
        ]);
        if (responsePaymentMethod.response?.data !== undefined) {
            let ListArr:any = [];
            responsePaymentMethod.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setPaymentMethod(ListArr)
        }
        if (responseType.response?.data !== undefined) {
            let ListArr:any = [];
            responseType.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setType(ListArr)
        }
        if (responseUser.response?.data !== undefined) {
            let ListArr:any = [];
            responseUser.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setUser(ListArr)
        }
        if (responseBranch.response?.data !== undefined) {
            let ListArr:any = [];
            responseBranch.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setbranch(ListArr)
        }
        if (responseCustomer.response?.data !== undefined) {
            let ListArr:any = [];
            responseCustomer.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setCustomers(ListArr)
        }
        if (responseSupplier.response?.data !== undefined) {
            let ListArr:any = [];
            responseSupplier.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setSupplier(ListArr)
        }
    }

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: page,
            limit: limit,
            ...filter,
        }
        if(formData?.name === "") {
            delete formData?.name
        }
        if(formData?.payment_method_id === 0) {
            delete formData?.payment_method_id
        }
        if(formData?.from && formData?.to) {
            formData.from = moment(formData?.from).startOf('day').valueOf()
            formData.to = moment(formData?.to).startOf('day').valueOf()
        }
        const url = `${baseUrl}/payment`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response?.response?.data)
            setTotalElements(response?.response?.total)
        }
    }


    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    configPage={configPage}
                    user={user}
                    customers={customers}
                    type={type}
                    branch={branch}
                    supplier={supplier}
                    paymentMethod={paymentMethod}
                    setFilter={(filter: any) => setFilter(filter)}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <DataTableList
                    setFilter={(filter: any) => setFilter(filter)}
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <Pagination
                    link={configPage.pathPage + '/list'}
                    setPage={(page: number) => setPage(page)}
                    page={page}
                    limit={limit}
                    setLimit={(limit: number) => setLimit(limit)}
                    totalElements={totalElements}
                />
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                {action?.type === 'add' && <ReceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>}
                {action?.type === 'view' && <ReceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()} onlyView={true}/>}
                {action?.type === 'edit' && <ReceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>}
            </ModalPopup>
        </React.Fragment>
    );
};

const getLabelByValue = (data:any, value:any) => {
    const result = data?.filter((item:any)=>{
        return item?.value === value
    })
    console.log('getLabelByValue', data, value, result)
    return result[0]?.label || ''
}

const DataTableList = (props: any) => {
    const { data, filter,setFilter, loading, limit, page, configPage, handleActionModal, paymentMethod} = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ minWidth: 120 }}>
                        Mã phiếu
                        {/* <div className="d-flex align-items-center" onClick={() => setFilter({
                                ...filter,
                                order_by: 'code',
                                sort: filter?.sort == 'asc' ? 'desc': 'asc'
                            })}>
                            <img style={{marginRight:5}} src={filter?.order_by != 'code' ? IconFilterNone : filter?.sort == 'desc' ? IconFilterDesc : IconFilterAsc} alt="sort" />
                            Mã phiếu
                        </div> */}
                    </th>
                    <th style={{ minWidth: 110 }}>Người nhận</th>
                    <th style={{ minWidth: 110 }}>Loại phiếu chi</th>
                    <th style={{ minWidth: 110 }}>Chi nhánh chi</th>
                    <th style={{ minWidth: 110 }}>Hình thức</th>
                    <th style={{ minWidth: 110 }}>Số tiền</th>
                    <th style={{ minWidth: 110 }}>Ngày chi</th>
                    <th style={{ minWidth: 110 }}>Nhóm phiếu</th>
                    <th style={{ minWidth: 110 }}>Trạng thái</th>
                    <th style={{ minWidth: 80 }}>Thao tác</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có phiếu chi nào!" />;
        }
        const gotoDetail = (item:any) => {
            props?.handleActionModal({type: 'view', data: item})
        }

        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                        <tr key={`${item?.id}-${index}`}>
                            <td onClick={() => gotoDetail(item)}>{item?.code}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.user_receiver_uid?.name || item?.customer_receiver_uid?.name || item?.supplier_receiver_uid?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.receipts_type_id?.name || '---'}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.branch_id?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.payment_method_id?.name || '---'}</td>
                            <td onClick={() => gotoDetail(item)}>{PriceUtils.format(item?.payment_total)}</td>
                            <td onClick={() => gotoDetail(item)}>{moment(item?.day).format('DD/MM/YYYY')}</td>
                            <td onClick={() => gotoDetail(item)}>{ getLabelByValue(ReceiptsGroup, item?.receipts_group)}</td>
                            <td onClick={() => gotoDetail(item)}>{getLabelByValue(StatusList, item?.status)}</td>
                            <td>
                            <div className="table-action">
                                    <div
                                        className="button-nutri"
                                        onClick={() => {
                                            props?.handleActionModal({type: 'edit', data: item})
                                        }}
                                    >
                                        <img
                                            style={{ border: "none" }}
                                            src={IconEdit}
                                            width={20}
                                            height={20}
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </td>
                        </tr>
                ))}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
        </div>
    );
};

const DataFilter = (props: any) => {
    const { setFilter, filter, user, branch, type, customers, supplier, paymentMethod} = props
    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            })
        }
    }

    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        setFilter({
            ...filter,
            page: 1,
            [name]: value
        })
    }

    const handleChangeFilterDate = (date:any) => {
        if(date.length === 2){
            const from = moment(date[0]).startOf("day").format('YYYY-MM-DD')
            const to = moment(date[1]).endOf("day").format('YYYY-MM-DD')
            setFilter({
                ...filter,
                from:from,
                to:to
            })
        }else if(date.length === 0){
            setFilter({
                ...filter,
                from:undefined,
                to:undefined
            })
        }   
    }
    
    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={4}>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                <img src={IconSearch} width={18} height={18} alt=""/>
                            </InputGroupAddon>
                            <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Mã phiếu chi hoặc mã chứng từ" />
                        </InputGroup>
                    </Col>
                    <Col xl={8}>
                        <Row>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Nhóm phiếu-"
                                    options={[{
                                        value:"",
                                        label: "-Nhóm phiếu-"
                                    },...ReceiptsGroup]}
                                    onChange={(value: any) => {
                                        console.log('ReceiptsGroup', value)
                                        handleChange({ target: { name: 'receipts_group', value: value.value } })
                                    }}
                                    value={ReceiptsGroup?.filter((option: any) => filter?.receipts_group === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Loại phiếu chi-"
                                    options={[
                                        {
                                            value: "",
                                            label: "-Loại phiếu chi-",
                                        },...type
                                    ]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'receipts_type_id', value: value.value } })
                                    }}
                                    value={type?.filter((option: any) => filter?.receipts_type_id === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Hình thức chi-"
                                    options={[{
                                        label:'-Hình thức chi-',
                                        value: 0
                                    },...paymentMethod]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'payment_method_id', value: value.value } })
                                    }}
                                    value={paymentMethod?.filter((option: any) => filter?.payment_method_id === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng thái-"
                                    options={StatusList}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'status', value: value.value } })
                                    }}
                                    value={StatusList?.filter((option: any) => filter?.status === option.value)}
                                ></Select>
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={12}>
                        <Row>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Cơ sở chi tiền-"
                                    options={[
                                        {
                                            value: "",
                                            label: "-Cơ sở chi tiền-",
                                        },...branch
                                    ]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'branch_id', value: value.value } })
                                    }}
                                    value={branch?.filter((option: any) => filter?.branch_id === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Người chi-"
                                    options={[
                                        {
                                            value: "",
                                            label: "-Người chi-",
                                        },
                                        ...user
                                    ]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'payment_uid', value: value.value } })
                                    }}
                                    value={user?.filter((option: any) => filter?.payment_uid === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={2}>
                                {filter?.receipts_group === 'customer'?
                                    <Select
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        placeholder="-Người nhận-"
                                        options={[
                                            {
                                                value: "",
                                                label: "-Người nhận-",
                                            },
                                            ...customers
                                        ]}
                                        onChange={(value: any) => {
                                            handleChange({ target: { name: 'customer_receiver_uid', value: value.value } })
                                        }}
                                        value={customers?.filter((option: any) => filter?.customer_receiver_uid === option.value)}
                                    ></Select>:
                                filter?.receipts_group === 'supplier'?
                                    <Select
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        placeholder="-Người nhận-"
                                        options={[
                                            {
                                                value: "",
                                                label: "-Người nhận-",
                                            },
                                            ...supplier
                                        ]}
                                        onChange={(value: any) => {
                                            handleChange({ target: { name: 'supplier_receiver_uid', value: value.value } })
                                        }}
                                        value={supplier?.filter((option: any) => filter?.supplier_receiver_uid === option.value)}
                                    ></Select>:
                                    <Select
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        placeholder="-Người nhận-"
                                        options={[
                                            {
                                                value: "",
                                                label: "-Người nhận-",
                                            },
                                            ...user
                                        ]}
                                        onChange={(value: any) => {
                                            handleChange({ target: { name: 'user_receiver_uid', value: value.value } })
                                        }}
                                        value={user?.filter((option: any) => filter?.user_receiver_uid === option.value)}
                                    ></Select>
                                }
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Người lập phiếu-"
                                    options={[
                                        {
                                            value: "",
                                            label: "-Người lập phiếu-",
                                        },
                                        ...user
                                    ]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'created_uid', value: value.value } })
                                    }}
                                    value={user?.filter((option: any) => filter?.created_uid === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <InputGroup className='form-control picker-custom'>
                                    <Flatpickr 
                                        value={[new Date(moment(filter?.from,'YYYY-MM-DD').startOf('day').valueOf()), new Date(moment(filter?.to,'YYYY-MM-DD').startOf('day').valueOf())]}
                                        onChange={(date:any) => { handleChangeFilterDate(date) }} 
                                        options={{
                                            mode: "range",
                                            locale: Vietnamese,
                                            dateFormat: "d/m/Y",
                                        }}
                                        className="flatpickr-input active"
                                        placeholder="Ngày chi"
                                    />
                                    <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, from: null, to:null})}}>
                                        <i className="uil-times mr-1"></i>
                                    </div>
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={2}>
                <div className="text-right">
                    <Button 
                        onClick={() => props?.handleActionModal({type: 'add', data: {}})}
                        color="success" className="ml-2"
                    ><img className='mr-1' style={{border: 'none'}} src={IconPlus} width={20} height={20} alt=""/>  Thêm</Button>
                </div>
            </Col>
        </Row>
    );
};

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)